export const NEW_VENDOR = "NEW_VENDOR";
export const ALL_VENDOR = "ALL_VENDOR";
export const VENDOR_BY_ID = "VENDOR_BY_ID";
export const UPDATE_VENDOR = "UPDATE_VENDOR";

